import { Component } from 'react';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { Table, TableContainerElement } from '@mews-commander/ui/legacy';
import { Checkbox, IconButton, IconName, Button, Stack } from '@optimus-web/core';
import ConversionDirection from '../../enums/ConversionDirection';
import ExchangeRateInput from '../ExchangeRateInput';

const isBaseToQuote = ({ conversionDirection }: $TSFixMe) => conversionDirection === ConversionDirection.BaseToQuote;

interface ExchangeTableProps {
    exchangeRates: {
        conversionRateToDefault?: string | number;
        currencyCode?: string;
        isAccepted?: boolean;
        conversionDirection?: string;
        errors?: $TSFixMe[];
    }[];
    changeRates: $TSFixMeFunction;
    enterpriseDefaultCurrencyCode?: string;
}
class ExchangeTable extends Component<ExchangeTableProps> {
    handleAcceptedChanged = (currencyCode: $TSFixMe) => () => {
        (this.props as $TSFixMe).toggleConversionStatus(currencyCode);
    };

    handleFromValueChanged = (currencyCode: $TSFixMe, prevValue: $TSFixMe) => (value: $TSFixMe) => {
        (this.props as $TSFixMe).updateConversionValue(currencyCode, prevValue, value);
    };

    handleToValueChanged = (currencyCode: $TSFixMe, prevValue: $TSFixMe) => (value: $TSFixMe) => {
        (this.props as $TSFixMe).updateConversionValue(currencyCode, prevValue, value);
    };

    handleDirectionChanged = (currencyCode: $TSFixMe) => () => {
        (this.props as $TSFixMe).toggleConversionDirection(currencyCode);
    };

    handleBlur = (currencyCode: $TSFixMe) => () => {
        (this.props as $TSFixMe).updateTouched(currencyCode);
    };

    tableMapping = [
        {
            valueKey: 'currency',
            title: <LocalizedText textKey={TextKey.Currency} />,
            render: (exchangeRate: $TSFixMe) => <span>{exchangeRate.currencyCode}</span>,
            columnWidth: '15%',
        },
        {
            valueKey: 'isAccepted',
            title: <LocalizedText textKey={TextKey.IsAccepted} />,
            render: (exchangeRate: $TSFixMe) => (
                <Checkbox
                    checked={exchangeRate.isAccepted}
                    onChange={this.handleAcceptedChanged(exchangeRate.currencyCode)}
                />
            ),
            columnWidth: '10%',
        },
        {
            valueKey: 'to',
            title: (
                <span>
                    <LocalizedText
                        textKey={TextKey.ToCurrency}
                        // @ts-expect-error $TSFixMeError: No overload matches this call.
                        substitutes={{ currencyCode: this.props.enterpriseDefaultCurrencyCode }}
                    />
                </span>
            ),
            render: (exchangeRate: $TSFixMe) => (
                <ExchangeRateInput
                    exchangeRate={exchangeRate}
                    shouldComputeExchangeRate={!isBaseToQuote(exchangeRate)}
                    // @ts-expect-error $TSFixMeError: Type '{ exchangeRate: any; shouldComputeExchangeRate: boolean; onChange: (value: any) => void; onBlur: () => void; }' is...
                    onChange={this.handleToValueChanged(exchangeRate.currencyCode, exchangeRate.conversionRate)}
                    onBlur={this.handleBlur(exchangeRate.currencyCode)}
                />
            ),
            columnWidth: '30%',
        },
        {
            render: (exchangeRate: $TSFixMe) => (
                <IconButton
                    onClick={this.handleDirectionChanged(exchangeRate.currencyCode)}
                    icon={
                        exchangeRate.conversionDirection === ConversionDirection.BaseToQuote
                            ? IconName.ArrowRight
                            : IconName.ArrowLeft
                    }
                    variant="ghost"
                    type="submit"
                />
            ),
            columnWidth: '10%',
        },
        {
            valueKey: 'from',
            title: (
                <span>
                    <LocalizedText
                        textKey={TextKey.FromCurrency}
                        // @ts-expect-error $TSFixMeError: No overload matches this call.
                        substitutes={{ currencyCode: this.props.enterpriseDefaultCurrencyCode }}
                    />
                </span>
            ),
            render: (exchangeRate: $TSFixMe) => (
                <ExchangeRateInput
                    exchangeRate={exchangeRate}
                    shouldComputeExchangeRate={isBaseToQuote(exchangeRate)}
                    // @ts-expect-error $TSFixMeError: Type '{ exchangeRate: any; shouldComputeExchangeRate: boolean; onChange: (value: any) => void; onBlur: () => void; }' is...
                    onChange={this.handleFromValueChanged(exchangeRate.currencyCode, exchangeRate.conversionRate)}
                    onBlur={this.handleBlur(exchangeRate.currencyCode)}
                />
            ),
            columnWidth: '30%',
        },
    ];

    handleSave = () => this.props.changeRates();

    render() {
        return (
            <TableContainerElement>
                <Table mapping={this.tableMapping} source={this.props.exchangeRates} />
                <Stack itemAlignment="center" alignment="end" spacing="100">
                    {/* @ts-expect-error $TSFixMeError: Type '{ children: Element; onClick: () => any; primary: true; }' is not assignable to type 'IntrinsicAttributes & Button... */}
                    <Button variant="primary" onClick={this.handleSave} primary type="submit">
                        <LocalizedText textKey={TextKey.Save} />
                    </Button>
                </Stack>
            </TableContainerElement>
        );
    }
}

export default ExchangeTable;
